import axios from 'axios'

export default {
  state: {
    insurances: JSON.parse(localStorage.getItem('insurances')) || null
  },
  mutations: {
    getAllInsurances(state, insurances){
      state.insurances = insurances
      localStorage.setItem('insurances',JSON.stringify(insurances))
    },
    approveInsurance(state, companyProfileId) {
      state.insurances[state.insurances.findIndex(insurance => insurance.companyProfileId === companyProfileId)].BORevisedStatus = 'accepted'
    },
    rejectInsurance(state, companyProfileId){
      state.insurances[state.insurances.findIndex(insurance => insurance.companyProfileId === companyProfileId)].BORevisedStatus = 'rejected'
    },
    blockInsurance(state, userId) {
      state.insurances[state.insurances.findIndex(insurance => insurance.taAdminUserProfile.userId === userId)].taAdminUserProfile.isBlocked = true
    },
    unblockInsurance(state, userId) {
      state.insurances[state.insurances.findIndex(insurance => insurance.taAdminUserProfile.userId === userId)].taAdminUserProfile.isBlocked = false
    },
  },
  actions: {
    getAllInsurances({commit}, credentials){
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_BASE_URL}admin/taCompanies/list`,
        {
          params:{
            pageSize: credentials.pageSize,
            pageNo: credentials.pageNo,
            activeStatus: credentials.activeStatus,
            sortBy: credentials.sortBy,
            dir: credentials.dir,
           // country: credentials.country
          }
        })
        .then(res => {
          console.log(res.data)
          commit('getAllInsurances', res.data.results)
          commit('setLoading', false)
          resolve(res)
        })
        .catch(err => {
          commit('setLoading', false)
          localStorage.removeItem('insurances')
          reject(err)
          console.log(err.response)
        })
      })
    },

    approveInsurance({commit}, credentials){
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}admin/reviseTACompany`, credentials)
          .then(res => {
            console.log(res)
            commit('approveInsurance', credentials.companyProfileId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    rejectInsurance({commit}, credentials){
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}admin/reviseTACompany`, credentials)
          .then(res => {
            console.log(res)
            commit('rejectInsurance', credentials.companyProfileId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    blockInsurance({commit}, credentials){
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
          .then(res => {
            console.log(res)
            commit('blockInsurance', credentials.userId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    unblockInsurance({commit}, credentials){
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
          .then(res => {
            console.log(res)
            commit('unblockInsurance', credentials.userId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

  }
}